import * as React from 'react';
import { Dialog, DialogType } from '@fluentui/react';
import { getId } from '@fluentui/react';
import { ContextualMenu } from '@fluentui/react';

export interface IDialogBasicExampleState {
    isDraggable: boolean;
}

export class QARTaskApproverDialog extends React.Component<{}, IDialogBasicExampleState> {

    // Use getId() to ensure that the IDs are unique on the page.
    // (It's also okay to use plain strings without getId() and manually ensure uniqueness.)
    _labelId: string = getId('dialogLabel');
    _subTextId: string = getId('subTextLabel');
    _dragOptions = {
        moveMenuItemText: 'Move',
        closeMenuItemText: 'Close',
        menu: ContextualMenu
    };

    state = {
        hideDialog: true
    }

    componentDidMount() {
        if(!this.props.hideDialog) {
            this._showDialog();
        }
        else {
            this._closeDialog();
        }
    }

    _showDialog = (): void => {
        this.setState({ hideDialog: false });
    };

    _closeDialog = (): void => {
        this.setState({ hideDialog: true });
        this.props.closeDialog();
    };

    render() {
        const { hideDialog } = this.state;
        const qarTaskElement = this.props.qarTask.props.task;

        return (
            <div>
                <Dialog
                    hidden={hideDialog}
                    onDismiss={this._closeDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: qarTaskElement.site.title,
                        styles: dialogContentStyles,
                    }}
                    modalProps={{
                        titleAriaId: this._labelId,
                        subtitleAriaId: this._subTextId,
                        isBlocking: true,
                        dragOptions: this._dragOptions
                    }}
                    >
                    {
                        this.props.qarTask 
                    }
                </Dialog>
            </div>
        );
    }
}

const dialogContentStyles = {
    inner: {
        padding: '0 10px',
    },
    content: {
        overflow: 'hidden',
    },
    header: {
        wordBreak: 'break-word'
    }
}



// WEBPACK FOOTER //
// ./src/components/ManageCenter/QARTaskApproverDialog.js